module.exports = __webpack_public_path__ + "static/ratflap_logo_web-21d966c8e5f45946b5f258b4d0243248.svg";